import { Link, useLocation } from "react-router-dom"; // Use Link for SPA navigation
import { useEffect } from "react";
import { Button } from "@/components/ui/button"; // Import Button
import { AlertTriangle } from "lucide-react"; // Import an icon

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.warn( // Use warn for non-critical errors
      "404 - Page Not Found: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    // Removed outer div, using main provided by StoreLayout
    <main className="flex items-center justify-center py-12 px-4 text-center bg-gray-50" style={{ minHeight: 'calc(100vh - 160px)' }}>
      <div className="max-w-md">
         <div className="flex justify-center mb-6 text-yellow-500">
             <AlertTriangle className="h-16 w-16" />
         </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-3">Oops! Página Não Encontrada</h1>
        <p className="text-base text-gray-600 mb-8">
           A página que você está procurando não existe ou foi movida. 
           Verifique o endereço digitado ou volte para o início.
        </p>
        <Button asChild size="lg"> 
          <Link to="/">Voltar para a Página Inicial</Link>
        </Button>
      </div>
    </main>
  );
};

export default NotFound;
